/* eslint-disable */

import React from "react";
import { useEffect, useState } from "react";
import { fetchGraphQL } from "../../../services/api-raindrop";
import RaindropButton from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import RaindropCopyable from "../../../ui-components/raindrop-copyable/raindrop-copyable.tsx";
import NimbusTable from "../../../ui-components/nimbus-table/nimbus-table.tsx";

const NimbusOrganisationsSearch = () => {
  const columns = [
    {
      title: "ID",
      accessor: "id",
    },
    {
      title: "Icon",
      accessor: "iconImg",
    },
    {
      title: "Name",
      accessor: "name",
    },

    {
      title: "Requires Transfer",
      accessor: "isRequiringTransfer",
    },
    {
      title: "Transfer requires attention",
      accessor: "isTransferRequiringAttention",
    },
    {
      title: "Go to page",
      accessor: "goToPage",
    },
  ];

  const [data, setData] = useState(null);

  useEffect(() => {
    fetchGraphQL(`
      query {
        organisationObjects{
          id
          name
          presignedUrlLogo
          isRequiringTransfer
          isTransferRequiringAttention
          
        }
      }
    `).then((response) => {
      if (response.errors) {
        console.error("Error fetching organisations:", response);
        return;
      }

      const newData = response.data.organisationObjects.map((org) => ({
        id: (
          <RaindropCopyable
            text={org.id}
            displayText={`${org.id.substring(0, 20)}...`}
          />
        ),
        name: <RaindropCopyable text={org.name} />,
        goToPage: (
          <RaindropButton
            title="Go to page"
            to={`/nimbus/organisations/${org.id}`}
          />
        ),
        iconImg: (
          <img
            src={org.presignedUrlLogo}
            alt={""}
            className="w-10 h-10 rounded-lg"
          />
        ),
        isRequiringTransfer: org.isRequiringTransfer ? "🟠 True" : "False",
        isTransferRequiringAttention: org.isTransferRequiringAttention
          ? "🟠 True"
          : "False",
      }));
      setData(newData);
    });
  }, []);

  return (
    <div className="flex flex-col justify-center text-center gap-2 items-center overflow-auto">
      <NimbusTable columns={columns} data={data} />
    </div>
  );
};

export default NimbusOrganisationsSearch;
